import { encodePeriodValue, GlobalPeriodSelect } from '@components'

import React, { ReactElement, useCallback, useEffect, useRef } from 'react'

import { useUserOrganization } from '@modules-deprecated/app/organization'

import { useGlobalFiscalYear } from '../../../../contexts/globalFiscalYearContext'
import { PeriodValue } from '../../../../types/periodValue'
import { getPeriodValueFromFiscalYear } from '../../../../utils/getPeriodValueFromFiscalYear'
import { useAccountFilters } from '../../hooks/useAccountFilters'

export const AccountPeriodSelector = (): ReactElement => {
  const { organization } = useUserOrganization()
  const [{ period: queryParamPeriod }, setQueryParams] = useAccountFilters()
  const { fiscalYear: globalFiscalYear } = useGlobalFiscalYear()
  const hasPeriodBeenSetRef = useRef(false)

  // Check the initial period
  useEffect(() => {
    if (!!organization?.id && globalFiscalYear !== undefined && !hasPeriodBeenSetRef.current) {
      setQueryParams((prevQuery) => {
        hasPeriodBeenSetRef.current = true

        if (!prevQuery.period) {
          return { period: encodePeriodValue(getPeriodValueFromFiscalYear(globalFiscalYear), organization.id) }
        }

        return prevQuery
      })
    }
  }, [globalFiscalYear, organization?.id, setQueryParams])

  const handlePeriodChange = useCallback(
    (periodValue: PeriodValue) => {
      if (!organization?.id) {
        return
      }

      setQueryParams({ period: encodePeriodValue(periodValue, organization.id) })
    },
    [organization, setQueryParams],
  )

  return <GlobalPeriodSelect encodedPeriod={queryParamPeriod} onChange={handlePeriodChange} placement="bottom-end" />
}
